// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "0156690b1e65440e010ed10060961abb196b8bef/static/js/" + ({"440":"datadogProfiler","581":"datadogRecorder"}[chunkId] || chunkId) + "." + {"98":"c3469f9b","215":"28b12c6b","440":"2a9a7941","496":"89e6df15","581":"04bc5b3b","731":"e93345ea","952":"a8f7192d"}[chunkId] + ".chunk.js";
};